// /auth/apple: the Return URL registered for the console's Services ID (WEB_PLAN.md §4.4). Sign in with Apple runs
// in popup mode, so Apple hands the result to the opener page and this route is normally never shown; Apple still
// requires the URL to exist and to equal `redirectURI`. If it does open (in the popup, or someone follows the link),
// close the popup, or go to the console, which routes by sign-in state.

import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { FullPageLoading } from './components/GateScreens';

export default function AppleCallbackPage() {
  const navigate = useNavigate();
  useEffect(() => {
    const isPopup = window.opener !== null && window.opener !== window;
    if (isPopup) {
      window.close();
    }
    // Browsers ignore close() for a tab the script didn't open; then move on instead of spinning forever.
    const timer = window.setTimeout(() => navigate('/', { replace: true }), isPopup ? 800 : 0);
    return () => window.clearTimeout(timer);
  }, [navigate]);
  return <FullPageLoading label="Signing in…" />;
}
